import React, { Component } from 'react';
import { Input, Form, Button } from 'antd';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

@withRouter
@inject('store')
@observer
export class EmailConfig extends Component {
    render() {
        return (
            <div style={{ marginTop: 15, width: 420 }}>
                <Form.Item label={'Send signals to:'}>
                    <Input value={this.props.store.botStore.pool.signal_email} />
                    <Button
                        onClick={() =>
                            this.props.store.botStore.generateSignalEmailAddress(
                                this.props.match.params.id
                            )
                        }
                        type={'primary'}
                    >
                        Generate Address
                    </Button>
                </Form.Item>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/SignalsView/TradingViewEmail/EmailConfig.js